import * as _ from 'lodash';
import { useState, type VoidFunctionComponent } from 'react';
import { ListGroupItem } from 'react-bootstrap';
import type { NoticeMatch } from '../../../../shared/types/routes/revisions';
import { FormGroup, icons, LabeledMultiTextInput, LabeledTextArea } from '../../generic';
import Button from '../../generic/Button';

import styles from './ManageNoticeFile.module.less';

const ManageNoticeFile: VoidFunctionComponent<{ file: NoticeMatch }> = ({ file }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ListGroupItem key={file.id}>
      <div className={styles.fileName}>{file.path}</div>
      <div className={styles.controls}>
        <Button
          type="secondary"
          size="medium"
          icon={file.ignored ? icons.eyeRegular : icons.eyeSlashRegular}
          onClick={_.noop}
        >
          {file.ignored ? 'Stop Ignoring' : 'Ignore'}
        </Button>
        <Button
          size="medium"
          icon={isOpen ? icons.minusSquareO : icons.pencil}
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? 'Hide' : 'Edit'}
        </Button>
      </div>
      {isOpen && (
        <div className={styles.content}>
          <FormGroup>
            <LabeledTextArea
              label="Raw Text"
              size="large"
              value={file.contents}
            />
            <LabeledMultiTextInput
              id="copyrights"
              label="Copyrights"
              size="large"
              values={file.copyrights || []}
            />
          </FormGroup>
        </div>
      )}
    </ListGroupItem>
  );
};

export default ManageNoticeFile;
